var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Card",
        [
          _vm.innerSpin
            ? _c("Spin", { attrs: { size: "large", fix: "" } })
            : _vm._e(),
          _c(
            "transition",
            { attrs: { name: "fade" } },
            [
              _vm.mainTable.sarchCardShow
                ? _c(
                    "Row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "24" } },
                        [
                          _c("search-card", {
                            attrs: {
                              form: _vm.mainTable.searchForm,
                              "table-load-event": _vm.getSeedFarmTableRecords,
                              "table-search": _vm.mainTable.tableSearch,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c("Col", { attrs: { span: "24" } }, [
                _c("div", { staticClass: "global-tool-bar" }, [
                  _c("div", { staticClass: "left-bar" }, [
                    _c("span", { staticClass: "title" }, [_vm._v("苗场管理")]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "right-bar" },
                    [
                      _vm.$checkAccessArray(["S"])
                        ? _c(
                            "Button",
                            {
                              staticClass: "btns",
                              attrs: {
                                size: "small",
                                shape: "circle",
                                type: "success",
                                icon: "ios-add-circle-outline",
                              },
                              on: { click: _vm.onSeedFarmCreate },
                            },
                            [_vm._v("新增")]
                          )
                        : _vm._e(),
                      _c(
                        "Button",
                        {
                          staticClass: "btns",
                          attrs: {
                            type: "primary",
                            size: "small",
                            shape: "circle",
                            icon: "ios-search",
                          },
                          on: {
                            click: function ($event) {
                              _vm.mainTable.sarchCardShow =
                                !_vm.mainTable.sarchCardShow
                            },
                          },
                        },
                        [_vm._v("搜索")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c("stand-pagination-table", {
                    attrs: {
                      columns: _vm.mainTable.columns,
                      data: _vm.mainTable.data,
                      loading: _vm.mainTable.loading,
                      "table-search": _vm.mainTable.tableSearch,
                      "table-load-event": _vm.getSeedFarmTableRecords,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: { title: "苗场信息", width: "60" },
          model: {
            value: _vm.seedFarmFormShow,
            callback: function ($$v) {
              _vm.seedFarmFormShow = $$v
            },
            expression: "seedFarmFormShow",
          },
        },
        [
          _c("div", { staticClass: "global-tool-bar" }, [
            _c("div", { staticClass: "left-bar" }),
            _c(
              "div",
              {
                staticClass: "right-bar",
                staticStyle: { "margin-bottom": "20px" },
              },
              [
                _c(
                  "Button",
                  {
                    attrs: { type: "success" },
                    on: {
                      click: function ($event) {
                        return _vm.doPrint()
                      },
                    },
                  },
                  [_vm._v("打印订购告知书")]
                ),
              ],
              1
            ),
          ]),
          _c(
            "Form",
            {
              ref: "seedFarmForm",
              attrs: {
                model: _vm.seedFarmForm,
                rules: _vm.ruleValidate,
                "label-position": "top",
              },
            },
            [
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: { label: "种苗场编号", prop: "seedFarmCode" },
                        },
                        [
                          _c("Input", {
                            attrs: {
                              disabled:
                                _vm.seedFarmForm.formEditMode !==
                                _vm.FORM_EDIT_MODE_CREATE,
                            },
                            model: {
                              value: _vm.seedFarmForm.seedFarmCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.seedFarmForm, "seedFarmCode", $$v)
                              },
                              expression: "seedFarmForm.seedFarmCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: { label: "种苗场名称", prop: "seedFarmName" },
                        },
                        [
                          _c("Input", {
                            model: {
                              value: _vm.seedFarmForm.seedFarmName,
                              callback: function ($$v) {
                                _vm.$set(_vm.seedFarmForm, "seedFarmName", $$v)
                              },
                              expression: "seedFarmForm.seedFarmName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: {
                            label: "所属区域",
                            prop: "seedFarmAreaUuid",
                          },
                        },
                        [
                          _c(
                            "Select",
                            {
                              attrs: { filterable: "" },
                              model: {
                                value: _vm.seedFarmForm.seedFarmAreaUuid,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.seedFarmForm,
                                    "seedFarmAreaUuid",
                                    $$v
                                  )
                                },
                                expression: "seedFarmForm.seedFarmAreaUuid",
                              },
                            },
                            _vm._l(_vm.areaSource, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.areaUuid,
                                  attrs: { value: item.areaUuid },
                                },
                                [_vm._v(_vm._s(item.areaName))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "省份", prop: "seedFarmProvince" } },
                        [
                          _c(
                            "Select",
                            {
                              attrs: {
                                filterable: "",
                                clearable: "",
                                placeholder: "请选择省",
                              },
                              on: { "on-change": _vm.onProvinceChange },
                              model: {
                                value: _vm.seedFarmForm.seedFarmProvince,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.seedFarmForm,
                                    "seedFarmProvince",
                                    $$v
                                  )
                                },
                                expression: "seedFarmForm.seedFarmProvince",
                              },
                            },
                            _vm._l(_vm.provinceOptions, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.regionUuid,
                                  attrs: { value: item.regionUuid },
                                },
                                [_vm._v(_vm._s(item.regionName))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "城市", prop: "seedFarmCity" } },
                        [
                          _c(
                            "Select",
                            {
                              attrs: {
                                filterable: "",
                                clearable: "",
                                placeholder: "请选择市",
                              },
                              on: { "on-change": _vm.onCityChange },
                              model: {
                                value: _vm.seedFarmForm.seedFarmCity,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.seedFarmForm,
                                    "seedFarmCity",
                                    $$v
                                  )
                                },
                                expression: "seedFarmForm.seedFarmCity",
                              },
                            },
                            _vm._l(_vm.cityOptions, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.regionUuid,
                                  attrs: { value: item.regionUuid },
                                },
                                [_vm._v(_vm._s(item.regionName))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "区/县", prop: "seedFarmDist" } },
                        [
                          _c(
                            "Select",
                            {
                              attrs: {
                                filterable: "",
                                clearable: "",
                                placeholder: "请选择区/县",
                              },
                              model: {
                                value: _vm.seedFarmForm.seedFarmDist,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.seedFarmForm,
                                    "seedFarmDist",
                                    $$v
                                  )
                                },
                                expression: "seedFarmForm.seedFarmDist",
                              },
                            },
                            _vm._l(_vm.distOptions, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.regionUuid,
                                  attrs: { value: item.regionUuid },
                                },
                                [_vm._v(_vm._s(item.regionName))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "地址" } },
                        [
                          _c("Input", {
                            model: {
                              value: _vm.seedFarmForm.seedFarmAddress,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.seedFarmForm,
                                  "seedFarmAddress",
                                  $$v
                                )
                              },
                              expression: "seedFarmForm.seedFarmAddress",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "联系人" } },
                        [
                          _c("Input", {
                            model: {
                              value: _vm.seedFarmForm.seedFarmContact,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.seedFarmForm,
                                  "seedFarmContact",
                                  $$v
                                )
                              },
                              expression: "seedFarmForm.seedFarmContact",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: {
                            label: "联系电话",
                            prop: "seedFarmContactPhone",
                          },
                        },
                        [
                          _c("Input", {
                            model: {
                              value: _vm.seedFarmForm.seedFarmContactPhone,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.seedFarmForm,
                                  "seedFarmContactPhone",
                                  $$v
                                )
                              },
                              expression: "seedFarmForm.seedFarmContactPhone",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "品牌名称", prop: "brandName" } },
                        [
                          _c("Input", {
                            model: {
                              value: _vm.seedFarmForm.brandName,
                              callback: function ($$v) {
                                _vm.$set(_vm.seedFarmForm, "brandName", $$v)
                              },
                              expression: "seedFarmForm.brandName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "默认转运站" } },
                        [
                          _c(
                            "Select",
                            {
                              attrs: { clearable: "", filterable: "" },
                              model: {
                                value: _vm.seedFarmForm.defaultDtbStationsUuid,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.seedFarmForm,
                                    "defaultDtbStationsUuid",
                                    $$v
                                  )
                                },
                                expression:
                                  "seedFarmForm.defaultDtbStationsUuid",
                              },
                            },
                            _vm._l(
                              _vm.distributionStationsOptions,
                              function (item, index) {
                                return _c(
                                  "Option",
                                  { key: index, attrs: { value: item.id } },
                                  [
                                    _vm._v(
                                      _vm._s(item.code) +
                                        " - " +
                                        _vm._s(item.name)
                                    ),
                                  ]
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "部门", prop: "department" } },
                        [
                          _c(
                            "Select",
                            {
                              attrs: { clearable: "", filterable: "" },
                              model: {
                                value: _vm.seedFarmForm.departmentUuid,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.seedFarmForm,
                                    "departmentUuid",
                                    $$v
                                  )
                                },
                                expression: "seedFarmForm.departmentUuid",
                              },
                            },
                            _vm._l(_vm.departmentList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.departmentUuid,
                                  attrs: { value: item.departmentUuid },
                                },
                                [_vm._v(_vm._s(item.departmentName))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: {
                            label: "选择发货日期",
                            prop: "seedFarmDeliveryWeek",
                          },
                        },
                        [
                          _c(
                            "Select",
                            {
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.seedFarmForm.seedFarmDeliveryWeek,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.seedFarmForm,
                                    "seedFarmDeliveryWeek",
                                    $$v
                                  )
                                },
                                expression: "seedFarmForm.seedFarmDeliveryWeek",
                              },
                            },
                            _vm._l(_vm.deliveryDays, function (day, index) {
                              return _c(
                                "Option",
                                { key: index, attrs: { value: day.value } },
                                [_vm._v(_vm._s(day.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: {
                            label: "苗场介绍",
                            prop: "seedFarmIntroduction",
                          },
                        },
                        [
                          _c("Input", {
                            attrs: { rows: 5, type: "textarea" },
                            model: {
                              value: _vm.seedFarmForm.seedFarmIntroduction,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.seedFarmForm,
                                  "seedFarmIntroduction",
                                  $$v
                                )
                              },
                              expression: "seedFarmForm.seedFarmIntroduction",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: {
                            label: "种苗定购告知书",
                            prop: "noticeContent",
                          },
                        },
                        [
                          _c("Input", {
                            attrs: {
                              id: "printContent",
                              rows: 30,
                              type: "textarea",
                            },
                            model: {
                              value: _vm.seedFarmForm.noticeContent,
                              callback: function ($$v) {
                                _vm.$set(_vm.seedFarmForm, "noticeContent", $$v)
                              },
                              expression: "seedFarmForm.noticeContent",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "示范视频" } },
                        [
                          [
                            _vm.readOnly == false && _vm.demonVideos.length < 5
                              ? _c(
                                  "Upload",
                                  {
                                    attrs: {
                                      action: "https://up-z2.qiniup.com/",
                                      data: _vm.uploadParams,
                                      format: ["mp4"],
                                      accept: ".mp4",
                                      "on-format-error": _vm.handleFormatError,
                                      "on-success":
                                        _vm.handleUploadVideoSuccess,
                                      "before-upload": _vm.beforeVideoUpload,
                                      "show-upload-list": _vm.showUploadList,
                                    },
                                  },
                                  [
                                    _c(
                                      "Button",
                                      {
                                        attrs: {
                                          icon: "ios-cloud-upload-outline",
                                        },
                                      },
                                      [_vm._v("上传视频")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "Row",
                              {
                                staticStyle: { "margin-top": "10px" },
                                attrs: { gutter: 16 },
                              },
                              _vm._l(_vm.demonVideos, function (item, index) {
                                return _c(
                                  "Col",
                                  { key: index, attrs: { span: "5" } },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "img-card" },
                                      [
                                        _c(
                                          "video",
                                          {
                                            attrs: {
                                              width: "150",
                                              height: "150",
                                              controls: "",
                                            },
                                          },
                                          [
                                            _c("source", {
                                              attrs: {
                                                src: item.src,
                                                type: "video/mp4",
                                              },
                                            }),
                                          ]
                                        ),
                                        _vm.readOnly == false
                                          ? _c("Icon", {
                                              staticClass: "icon-delete",
                                              attrs: { type: "md-trash" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deleteVideo(index)
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              }),
                              1
                            ),
                          ],
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _vm.$checkAccessArray(["S", "B", "C"])
                ? _c(
                    "Button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSave } },
                    [_vm._v("确认")]
                  )
                : _vm._e(),
              _c(
                "Button",
                { attrs: { type: "error" }, on: { click: _vm.onCancel } },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: { title: "苗场信息", width: "60" },
          model: {
            value: _vm.seedFarmDeptFormShow,
            callback: function ($$v) {
              _vm.seedFarmDeptFormShow = $$v
            },
            expression: "seedFarmDeptFormShow",
          },
        },
        [
          _c("div", { staticClass: "global-tool-bar" }, [
            _c("div", { staticClass: "left-bar" }),
          ]),
          _c(
            "Form",
            {
              ref: "seedFarmDeptForm",
              attrs: {
                model: _vm.seedFarmForm,
                rules: _vm.ruleValidate,
                "label-position": "top",
              },
            },
            [
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: { label: "种苗场编号", prop: "seedFarmCode" },
                        },
                        [
                          _c("Input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.seedFarmForm.seedFarmCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.seedFarmForm, "seedFarmCode", $$v)
                              },
                              expression: "seedFarmForm.seedFarmCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: { label: "种苗场名称", prop: "seedFarmName" },
                        },
                        [
                          _c("Input", {
                            attrs: { readonly: "" },
                            model: {
                              value: _vm.seedFarmForm.seedFarmName,
                              callback: function ($$v) {
                                _vm.$set(_vm.seedFarmForm, "seedFarmName", $$v)
                              },
                              expression: "seedFarmForm.seedFarmName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "用友部门", prop: "ysDeptCode" } },
                        [
                          _c(
                            "Select",
                            {
                              attrs: { clearable: "", filterable: "" },
                              on: { "on-select": _vm.onSelectYSDept },
                              model: {
                                value: _vm.seedFarmForm.ysDeptCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.seedFarmForm, "ysDeptCode", $$v)
                                },
                                expression: "seedFarmForm.ysDeptCode",
                              },
                            },
                            _vm._l(_vm.YSDeptOptions, function (item) {
                              return _c(
                                "Option",
                                { key: item.code, attrs: { value: item.code } },
                                [
                                  _vm._v(
                                    _vm._s(item.code) +
                                      " - " +
                                      _vm._s(item.name)
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _vm.$checkAccessArray(["R", "S"])
                ? _c(
                    "Button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.onDeptSave },
                    },
                    [_vm._v("确认")]
                  )
                : _vm._e(),
              _c(
                "Button",
                {
                  attrs: { type: "error" },
                  on: {
                    click: function ($event) {
                      _vm.seedFarmDeptFormShow = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: { title: "苗场定金比例设置" },
          model: {
            value: _vm.seedFarmDepositDueRateFormShow,
            callback: function ($$v) {
              _vm.seedFarmDepositDueRateFormShow = $$v
            },
            expression: "seedFarmDepositDueRateFormShow",
          },
        },
        [
          _c(
            "Form",
            {
              ref: "seedFarmDepositDue",
              attrs: {
                model: _vm.seedFarmDepositDueRateForm,
                "label-position": "top",
              },
            },
            [
              _c(
                "Row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: { label: "种苗场编号", prop: "seedFarmCodeB" },
                        },
                        [
                          _c("Input", {
                            attrs: { disabled: "" },
                            model: {
                              value:
                                _vm.seedFarmDepositDueRateForm.seedFarmCode,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.seedFarmDepositDueRateForm,
                                  "seedFarmCode",
                                  $$v
                                )
                              },
                              expression:
                                "\n                                seedFarmDepositDueRateForm.seedFarmCode\n                            ",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: { label: "种苗场名称", prop: "seedFarmNameB" },
                        },
                        [
                          _c("Input", {
                            attrs: { disabled: "" },
                            model: {
                              value:
                                _vm.seedFarmDepositDueRateForm.seedFarmName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.seedFarmDepositDueRateForm,
                                  "seedFarmName",
                                  $$v
                                )
                              },
                              expression:
                                "\n                                seedFarmDepositDueRateForm.seedFarmName\n                            ",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: {
                            label:
                              "最低定金比例(百分比,如10即为10%,如0即为苗场代下单时,可将定金比例调整至0)",
                          },
                        },
                        [
                          _c("Input", {
                            model: {
                              value:
                                _vm.seedFarmDepositDueRateForm.depositDueRate,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.seedFarmDepositDueRateForm,
                                  "depositDueRate",
                                  $$v
                                )
                              },
                              expression:
                                "\n                                seedFarmDepositDueRateForm.depositDueRate\n                            ",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "是否启用" } },
                        [
                          _c(
                            "RadioGroup",
                            {
                              model: {
                                value: _vm.seedFarmDepositDueRateForm.isEnable,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.seedFarmDepositDueRateForm,
                                    "isEnable",
                                    $$v
                                  )
                                },
                                expression:
                                  "seedFarmDepositDueRateForm.isEnable",
                              },
                            },
                            [
                              _c("Radio", { attrs: { label: "启用" } }, [
                                _c("span", [_vm._v("启用")]),
                              ]),
                              _c("Radio", { attrs: { label: "停用" } }, [
                                _c("span", [_vm._v("停用")]),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _vm.$checkAccessArray(["S"])
                ? _c(
                    "Button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.onSaveDepositDueRate },
                    },
                    [_vm._v("确认")]
                  )
                : _vm._e(),
              _c(
                "Button",
                {
                  attrs: { type: "error" },
                  on: { click: _vm.onCancelDepositDueRate },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: { title: "联动供货数据" },
          model: {
            value: _vm.seedFarmLinkPreSalePlansShow,
            callback: function ($$v) {
              _vm.seedFarmLinkPreSalePlansShow = $$v
            },
            expression: "seedFarmLinkPreSalePlansShow",
          },
        },
        [
          _c(
            "Form",
            {
              ref: "seedFarmLinkPlans",
              attrs: {
                model: _vm.seedFarmDepositDueRateForm,
                "label-position": "top",
              },
            },
            [
              _c(
                "Row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: { label: "种苗场编号", prop: "seedFarmCodeB" },
                        },
                        [
                          _c("Input", {
                            attrs: { disabled: "" },
                            model: {
                              value:
                                _vm.seedFarmDepositDueRateForm.seedFarmCode,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.seedFarmDepositDueRateForm,
                                  "seedFarmCode",
                                  $$v
                                )
                              },
                              expression:
                                "\n                                seedFarmDepositDueRateForm.seedFarmCode\n                            ",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: { label: "种苗场名称", prop: "seedFarmNameB" },
                        },
                        [
                          _c("Input", {
                            attrs: { disabled: "" },
                            model: {
                              value:
                                _vm.seedFarmDepositDueRateForm.seedFarmName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.seedFarmDepositDueRateForm,
                                  "seedFarmName",
                                  $$v
                                )
                              },
                              expression:
                                "\n                                seedFarmDepositDueRateForm.seedFarmName\n                            ",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: {
                            label: "联动供货数据",
                            prop: "seedFarmCodeB",
                          },
                        },
                        [
                          _c(
                            "i-switch",
                            {
                              attrs: { size: "large" },
                              model: {
                                value:
                                  _vm.seedFarmDepositDueRateForm
                                    .linkPreSalePlans,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.seedFarmDepositDueRateForm,
                                    "linkPreSalePlans",
                                    $$v
                                  )
                                },
                                expression:
                                  "\n                                seedFarmDepositDueRateForm.linkPreSalePlans\n                            ",
                              },
                            },
                            [
                              [
                                _c(
                                  "span",
                                  { attrs: { slot: "open" }, slot: "open" },
                                  [_vm._v("开启")]
                                ),
                              ],
                              [
                                _c(
                                  "span",
                                  { attrs: { slot: "close" }, slot: "close" },
                                  [_vm._v("关闭")]
                                ),
                              ],
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _vm.$checkAccessArray(["B", "S"])
                ? _c(
                    "Button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.onSaveLinkPlans },
                    },
                    [_vm._v("确认")]
                  )
                : _vm._e(),
              _c(
                "Button",
                {
                  attrs: { type: "error" },
                  on: { click: _vm.onCancelLinkPlans },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }